<div class="tws-flex tws-flex-col tws-items-center">
  <button class="email-button tws-w-full" mat-mini-fab (click)="irAEmails()">
    <mat-icon matBadgeColor="accent" class="email-button__icon"
      >mail_outline</mat-icon
    >
  </button>
  <span class="tws-mt-2 tws-text-xs">Buzon</span>
</div>
